<template>
    <div class="startIcon" :style="{left: left + 'px', top: top + 'px'}">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <g id="Ellipse_13-3" data-name="Ellipse 13-3">
                <circle cx="16" cy="16" r="16" style="fill: #e25a10"/>
                <circle cx="16" cy="16" r="15" style="fill: none;stroke: #fff;stroke-width: 2px"/>
            </g>
            <circle id="dot" cx="16" cy="16" r="6" style="fill: #fff" v-if="type=='start'"/>
            <g id="end" data-name="Gruppe 1211" v-if="type == 'end'">
                <path id="Pfad_90" data-name="Pfad 90" d="M34.6,26.3c0,3.48-6.3,9.85-6.3,9.85S22,29.78,22,26.3a6.3,6.3,0,0,1,12.6,0Z" transform="translate(-12 -12)" style="fill: none;stroke: #fff;stroke-linejoin: round;stroke-width: 2px"/>
                <path id="Pfad_91" data-name="Pfad 91" d="M31,26.3a2.69,2.69,0,1,1-2.69-2.69A2.7,2.7,0,0,1,31,26.3Z" transform="translate(-12 -12)" style="fill: #fff"/>
            </g>
        </svg>
        <svg id="ring" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <circle id="" cx="16" cy="16" r="15" style="fill: none;stroke: #fff;stroke-width: 2px"/>
        </svg>
    </div>
</template>

<script>
    import { gsap } from 'gsap';
    // let timeline = gsap.timeline({repeat: -1});
    // timeline.to('#ring', {duration: 2, x: 50 })
    export default {
        name: 'MapStartIcon',
        mounted() {
            let timeline = gsap.timeline({repeat: -1});
            timeline.to('#ring', {duration: 2, opacity: 0, scale: 2, transformOrigin:'50% 50%' })
        },
        props: ['left', 'top', 'type']
    }

</script>

<style lang="scss" scoped>
    .startIcon{
        transform: translate(-50%, -50%);
        position: absolute;
    }
    svg {
        width: 40px;
    }
    #ring {
        position: absolute;
        left: 0;
    }

</style>